import { render, staticRenderFns } from "./document.vue?vue&type=template&id=348d53a6&scoped=true&"
import script from "./document.vue?vue&type=script&lang=ts&"
export * from "./document.vue?vue&type=script&lang=ts&"
import style0 from "./document.vue?vue&type=style&index=0&id=348d53a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d53a6",
  null
  
)

export default component.exports